import { render, staticRenderFns } from "./teacherCorrection.vue?vue&type=template&id=a262b8f8"
import script from "./teacherCorrection.vue?vue&type=script&lang=js"
export * from "./teacherCorrection.vue?vue&type=script&lang=js"
import style0 from "./teacherCorrection.vue?vue&type=style&index=0&id=a262b8f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports